import React, { useMemo, useState } from "react";
import { CardBasic, Scroller, SecondaryButton } from "extranet-component-library";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { getAge, isMobile, parseDate } from "../utils/parsers";
import { useStores } from "../hooks/useStores";
import avatar from "../assets/img/red-user.svg";
import mail from "../assets/img/MAIL.svg";
import { MENU } from "../utils/constants";

interface CustomProps {
    profile: any;
    notifications: Array<any>
}

const ProfileInfo = ({ profile, notifications }: CustomProps) => {
    const { t } = useTranslation();
    const history = useHistory();
    const [isOpen, setOpen] = useState(-1);
    const { notificationStore, myTibStore } = useStores();
    const { notification } = notificationStore;

    const curAge = useMemo(
        () => getAge(profile.birthday),
        [profile.birthday]
    ) ;

    const handleOpen = (id: number, index: number) => {
        notificationStore.getNotification(id).then(() => setOpen(index));
    };

    const onClickDetails = (isOpen: boolean, alertId: number, index: number) => {
        if (isOpen) {
            setOpen(-1);
        } else {
            handleOpen(alertId, index);
        }
    }

    return (
        <div className="vertical-flex">
            <CardBasic
                style={{
                    margin: isMobile() ? "0.5rem" : "0rem 1rem 0rem 0rem",
                    width: "95%",
                }}
                content={
                    <>
                        <div className="user">
                            <div className="avatar">
                                <img
                                    src={avatar}
                                    alt="avatar"
                                />
                            </div>
                            {profile ? (
                                <div className="profile-container">
                                    <div className="tib-bold">
                                        {profile.name} {profile.surname1} {profile.surname2}
                                    </div>
                                    <div className="italic">{profile.email}</div>
                                    <div>
                                        <span className="tib-bold">
                                            {parseDate(profile.birthday)}
                                        </span>
                                        {curAge ? " (" + curAge + " " + t("age") + ")" : ""}
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        <div className="grey-card">
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: t("alerts.alert_fav_lines", {
                                        alerts: myTibStore.getAlertsLines(),
                                    }),
                                }}
                            />
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: t("alerts.alert_fav_stops", {
                                        alerts: myTibStore.getAlertsStops(),
                                    }),
                                }}
                            />
                            <SecondaryButton
                                text={t("edit_alerts")}
                                onClick={() => history.push(MENU.FAVORITES.URL)}
                            />
                        </div>
                    </>
                }
            />
            <div className="my-notifications">
                {notifications.length ? (
                    <CardBasic
                        style={{
                            width: "95%",
                            margin: isMobile() ? "0.5rem" : "0 1rem 0 0",
                        }}
                        content={
                            <>
                                <div className="title">{t("my_alerts")}</div>
                                <Scroller
                                    height="120px"
                                    content={notifications.map(
                                        (alert: any, index: number) => {
                                            return (
                                                <div key={index}>
                                                    <div className="notification">
                                                        <img src={mail} alt="mail" />
                                                        <div className="text">{alert.title}</div>
                                                        <div
                                                            onClick={() => onClickDetails(isOpen === index, alert.id, index)}
                                                            className="button"
                                                        >
                                                            {isOpen === index ? t("see_less") : t("see_more")}
                                                        </div>
                                                    </div>
                                                    {isOpen === index && notification ? (
                                                        <div
                                                            className="detail"
                                                            dangerouslySetInnerHTML={{
                                                                __html: notification.description,
                                                            }}
                                                        ></div>
                                                    ) : null}
                                                </div>
                                            );
                                        }
                                    )}
                                />
                            </>
                        }
                    />
                ) : null}
            </div>
        </div>
    );
};

export default ProfileInfo;
